import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import { ErrorPage } from './components/error-page/ErrorPage';
import { constants } from './constants';
import { AnonymousLayout } from './routes/_anonymous';
import { LoginRoute } from './routes/_anonymous.login';
import { ResetPasswordRoute } from './routes/_anonymous.reset-password';
import { SignUpRoute } from './routes/_anonymous.sign-up';
import { AuthenticatedLayout } from './routes/_authenticated';
import { MainLayout } from './routes/_authenticated._main';
import { CompanyRoute } from './routes/_authenticated._main.company';
import { DriverRoute } from './routes/_authenticated._main.driver';
import { DriverPreferencesRoute } from './routes/_authenticated._main.driver.preferences';
import { DriversRoute } from './routes/_authenticated._main.drivers';
import { DriverAddRoute } from './routes/_authenticated._main.drivers.add';
import { FleetRoute } from './routes/_authenticated._main.invoicing.fleet';
import { FortnightlyInvoicingRoute } from './routes/_authenticated._main.invoicing.fortnight';
import { InvoicesRoute } from './routes/_authenticated._main.invoicing.invoices';
import { MonthlyInvoicingRoute } from './routes/_authenticated._main.invoicing.month';
import { TransactionRoute } from './routes/_authenticated._main.invoicing.transaction';
import { TransactionsRoute } from './routes/_authenticated._main.invoicing.transactions';
import { SettingsRoute } from './routes/_authenticated._main.settings';
import { TripsCalendarRoute } from './routes/_authenticated._main.trips.calendar';
import { TripsListRoute } from './routes/_authenticated._main.trips.list';
import { TripsPackageRoute } from './routes/_authenticated._main.trips.trip-package';
import { VehicleRoute } from './routes/_authenticated._main.vehicle';
import { VehiclesRoute } from './routes/_authenticated._main.vehicles';
import { VehicleAddRoute } from './routes/_authenticated._main.vehicles.add';
import { SubscriptionLayout } from './routes/_authenticated._subscription';
import { SubscriptionRoute } from './routes/_authenticated._subscription.subscription';
import { TakeOverRoute } from './routes/takeover';

const router = createBrowserRouter(
  [
    { path: '/takeover', element: <TakeOverRoute />, errorElement: <ErrorPage /> },
    {
      element: <AnonymousLayout />,
      errorElement: <ErrorPage />,
      children: [
        { path: '/login', element: <LoginRoute />, errorElement: <ErrorPage /> },
        { path: '/sign-up', element: <SignUpRoute />, errorElement: <ErrorPage /> },
        { path: '/reset-password', element: <ResetPasswordRoute />, errorElement: <ErrorPage /> },
      ],
    },
    {
      element: <AuthenticatedLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          element: <SubscriptionLayout />,
          errorElement: <ErrorPage />,
          children: [{ path: '/subscription', element: <SubscriptionRoute />, errorElement: <ErrorPage /> }],
        },
        {
          element: <MainLayout />,
          errorElement: <ErrorPage />,

          children: [
            { path: '/', element: <Navigate to="/trips/list?state=INCOMING" replace />, errorElement: <ErrorPage /> },
            { path: '/trips/list', element: <TripsListRoute />, errorElement: <ErrorPage /> },
            { path: '/trips/calendar', element: <TripsCalendarRoute />, errorElement: <ErrorPage /> },
            { path: '/trips/packages', element: <TripsPackageRoute />, errorElement: <ErrorPage /> },
            { path: '/invoicing/fortnight', element: <FortnightlyInvoicingRoute />, errorElement: <ErrorPage /> },
            { path: '/invoicing/month', element: <MonthlyInvoicingRoute />, errorElement: <ErrorPage /> },
            { path: '/invoicing/invoices', element: <InvoicesRoute />, errorElement: <ErrorPage /> },
            {
              path: '/invoicing/transactions/:transactionId',
              element: <TransactionRoute />,
              errorElement: <ErrorPage />,
            },
            { path: '/invoicing/transactions', element: <TransactionsRoute />, errorElement: <ErrorPage /> },
            { path: '/invoicing/fleet', element: <FleetRoute />, errorElement: <ErrorPage /> },
            { path: '/vehicles', element: <VehiclesRoute />, errorElement: <ErrorPage /> },
            { path: '/vehicles/add', element: <VehicleAddRoute />, errorElement: <ErrorPage /> },
            { path: '/vehicles/:vehicleKey', element: <VehicleRoute />, errorElement: <ErrorPage /> },
            { path: '/drivers/:driverKey', element: <DriverRoute />, errorElement: <ErrorPage /> },
            { path: '/drivers', element: <DriversRoute />, errorElement: <ErrorPage /> },
            { path: '/drivers/add', element: <DriverAddRoute />, errorElement: <ErrorPage /> },
            {
              path: '/drivers/:driverKey/preferences',
              element: <DriverPreferencesRoute />,
              errorElement: <ErrorPage />,
            },
            { path: '/company', element: <CompanyRoute />, errorElement: <ErrorPage /> },
            { path: '/settings', element: <SettingsRoute />, errorElement: <ErrorPage /> },
          ],
        },
      ],
    },
  ],
  {
    basename: constants.basename,
  },
);

export const Router = () => {
  return <RouterProvider router={router} />;
};
